module.exports = __webpack_public_path__ + "static/media/R-Smart W-Classic.f1459e36.mp4";